import { Box, Typography } from "@mui/material";
import { CategoriesSlider } from "./contentList";
import {
  FocusContext,
  useFocusable,
} from "@noriginmedia/norigin-spatial-navigation";
import styled from "styled-components";
import { useCallback, useRef } from "react";
import { BackBarButtonMini } from "../common/backBarButton";
import smoothScroll from "../../utils/animateScroll";
import { useInputMode } from "../../utils/hooks/useInputMode";

const ContentWrapper = styled.div`
  flex: 1;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  padding: 2rem 4rem;
  padding-bottom: 0;
`;

const ScrollingRows = styled.div`
  overflow-y: auto;
  overflow-x: hidden;
  height: 100vh;
  width: 100%;
`;

const MoftabakhContent = ({ data }) => {
  const { ref, focusKey } = useFocusable();

  const innerRef = useRef(null);
  const { isMouseFocus } = useInputMode();

  const onRowFocus = useCallback(
    (props) => {
      if (isMouseFocus) return;
      const { y, height } = props;

      const targetScroll = y > height - 200 ? y - 200 : 0;

      smoothScroll(ref, targetScroll, 500);
    },
    [ref, isMouseFocus]
  );

  return (
    <ContentWrapper>
      <FocusContext.Provider value={focusKey}>
        <ScrollingRows ref={ref}>
          <div>
            <div className="flex items-center mb-5">
              <BackBarButtonMini />
              <Typography
                variant="h4"
                fontWeight={700}
                mb={0}
                mr={3}
                color={"white"}
              >
                اکران آنلاین
              </Typography>
            </div>
            {data.length > 0 ? (
              <CategoriesSlider
                rowTitle={""}
                movies={data}
                onFocus={onRowFocus}
              />
            ) : (
              <div className="bg-[#212121] p-5 rounded-xl text-lg">
                <Typography color={"white"} fontFamily={"AnjomanMaxFN-Regular"}>
                  {" "}
                  محتوایی یافت نشد
                </Typography>
              </div>
            )}
          </div>
        </ScrollingRows>
      </FocusContext.Provider>
    </ContentWrapper>
  );
};

export default MoftabakhContent;
